<template>
  <div class="menu" style="background: url(static/images/backgroundcs.png) no-repeat bottom;
    background-color: #A7D7F5;
    background-size: 100%;
    height: 100%;">
      <div class="topLogo">
          <img class="leftLogo" src="static/images/logoblack.png">
          <img class="rightLogo" src="static/images/wsbsdt.png">
      </div>
      <div class="grid margin-top-10">
        <div class="gridWarp nopadding noborder">
            <div class="gridCell lof-3" @click="checkPermissionOpenPage()">
                <div class="btimg d_icon_10" style="background: url(static/images/jt.png) no-repeat;
                background-size: 333.33%;
                background-color: #3C8DFF;">
                </div>
                <p class="text">联合查询</p>
            </div>

        </div>
      </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import api from "../fetch/api";
import * as _ from "../util/tool";
import * as types from '../vuex/types';
import service from "@/fetch/service";

export default {
  data() {
    return {
    };
  },
  computed:{
    pageParamsType: {
      // getter
      get: function () {
          return this.$route.query.type;
      }
    }
  },
  created() {
      _.isHaveToken(this.$router);
      console.log(this.pageParamsType)
      console.log(this.$route)
  },
  methods: {
      checkPermissionOpenPage() {
        service
        .checkPermission({})
        .then(res => {
            console.log(res);
            if (res.result) {
                this.$router.push('/home');
            }else {
                _.toast("无权访问", 'fail');
            }

        })
        .catch(error => {
            console.log(error);
        });
      },
      openPage(pageName) {
          service
            .roomCheckPermission({})
            .then(res => {
                console.log(res);
                if (res.result) {
                    this.$router.push(pageName);
                }else {
                    _.toast("无权访问", 'fail');
                }

            })
            .catch(error => {
                console.log(error);
            });
      }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/css/function";
.menu {
    .topLogo {
        height: px2rem(100px);
        width: 100%;
        padding: px2rem(20px);
        background: #fff;
        display: flex;
        .leftLogo {
            width: 55%;
            align-self: center;
        }
        .rightLogo {
            width: 40%;
            align-self: center;
        }
    }
    .gridCell {
        display: flex;
        flex-flow: column;
        align-items: center;
        .btimg {
            width: px2rem(120px);
            height: px2rem(120px);
            border-radius: px2rem(10px);
        }
        .d_icon_10 {
            background-position-x: 0;
            background-position-y: px2rem(-410px);
        }
        .text {
            margin-top: px2rem(20px);
            font-size: px2rem(28px);
        }
    }
    .flex-1 {
        flex: 1;
    }
}
</style>


// WEBPACK FOOTER //
// indexMenuJointQuery.vue?aef00f34